__turbopack_context__.v({
  "banner": "GooglePreferredSourceHeader-module__XH0fWW__banner",
  "cta": "GooglePreferredSourceHeader-module__XH0fWW__cta",
  "fallback": "GooglePreferredSourceHeader-module__XH0fWW__fallback",
  "googleButton": "GooglePreferredSourceHeader-module__XH0fWW__googleButton",
  "text": "GooglePreferredSourceHeader-module__XH0fWW__text",
  "wrap": "GooglePreferredSourceHeader-module__XH0fWW__wrap",
});
